/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum MediaType {
  Advertisement = "ADVERTISEMENT",
  Album = "ALBUM",
  Article = "ARTICLE",
  Category = "CATEGORY",
  Channel = "CHANNEL",
  Club = "CLUB",
  Competitions = "COMPETITIONS",
  Episode = "EPISODE",
  Event = "EVENT",
  FootballEvent = "FOOTBALL_EVENT",
  FootballSeason = "FOOTBALL_SEASON",
  Intro = "INTRO",
  League = "LEAGUE",
  Live = "LIVE",
  Match = "MATCH",
  Package = "PACKAGE",
  Person = "PERSON",
  Player = "PLAYER",
  Podcast = "PODCAST",
  Premiere = "VIDEO_PREMIERE",
  Program = "PROGRAM",
  Season = "SEASON",
  Series = "SERIES",
  Team = "TEAM",
  Video = "VOD",
  Voucher = "VOUCHER",
}
